class MobileMenu {
	constructor(selectors) {
		let {toggle, menu, main_nav} = selectors;

		// Get "burger" icon used to toggle mobile menu
		this.$menu_toggle 	= document.querySelector(toggle);
		this.$menu 			= document.querySelector(menu);
		this.$main_nav 		= document.querySelector(main_nav);

		// Return out if menu toggle can't be found
		if (this.$menu_toggle === null) return;

		// Store state of menu open/closed
		this.is_open = false;

		// Add click event to burger menu
		this.$menu_toggle.addEventListener('click', e => {
			// Flip menu open status
			this.is_open = !this.is_open;

			// Toggle class on toggle button
			this.$menu_toggle.classList.toggle('is-active', this.is_open);

			this.$main_nav.classList.toggle('site-header--mobile-menu-active', this.is_open);

			// Toggle class on mobile menu
			this.$menu.classList.toggle('is-active', this.is_open);
		});
	}
}

// Create new instance of mobile menu
// passing in selectors
const menu = new MobileMenu({
	toggle: '.menu-toggle',
	menu: '.mobile-menu',
	main_nav: '.site-header'
});
